module.exports = __webpack_public_path__ + "static/media/loading.4088b05d.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/loading.gif
 ** module id = 67
 ** module chunks = 0
 **/